import SHPie from './src/pie.vue';


/**
 * ECharts绘制饼图或这圆环图
 */

/* istanbul ignore next */
SHPie.install = function(Vue) {
  Vue.component('sh-pie', SHPie);
};
export default SHPie;


// WEBPACK FOOTER //
// ./src/components/base/view/cmps/charts/pie/index.js